<template>

  <div>
  <section class="relative nooverflow pt-5 blue-grey darken-3 hidden-sm-and-down" style="--background:#424242;--height:280px">

		<div style="height: 100px;width: 100%;background: linear-gradient(170deg, rgba(64, 79, 86, 0.92), rgb(55, 71, 79));position: absolute;top: -54px;transform: rotate(181deg);">.</div>
		<!--<img src="../../../assets/city.png" style="position: absolute;right: -12px;bottom: -70px;z-index: 8;opacity: 0.035;"/>-->
				<v-container grid-list-xl class="mt-4 ml-5 mr-5">
					<v-layout row wrap class="relative ml-4 mr-4">


						<v-flex sm12 md4 class="relative">
							<v-layout column align-center>
							<v-card class="relative transparent elevation-0" width="370px">

								<v-card-title primary-title style="padding-bottom:0px">
									<img src="../../../assets/lingoLogo.png" style="position: relative;left: -7px;top: 6px;opacity: 0.1;"/>
									<span style="color:rgb(247, 247, 245);padding-top: 5px;padding-bottom: 0px;position: relative;top: -45px;left: -19px;">LingoAV &copy; {{ new Date().getFullYear() }}</span>
								</v-card-title>

								<v-card-text style="padding-top: 5px;padding-left: 7px;position: relative;left: 140px;top: -100px;">

									<div class="mb-1"><router-link to="/programInfo" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Project Info</router-link></div>
									<div class="mb-1"><router-link to="/terms"  class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Terms of Service</router-link></div>
									<div class="mb-1"><router-link to="/legal" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Privacy Policy</router-link></div>
									<div class="mb-1"><router-link to="/cookiePolicy" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Cookie Policy</router-link></div>

								</v-card-text>
							</v-card>
							</v-layout>
						</v-flex>


						<v-flex sm12 md4 class="relative">
							<v-layout column align-center>
							<v-card class="relative transparent elevation-0"  width="250px">

								<v-card-title primary-title style="padding-bottom:0px;padding-top:38px;padding-bottom:5px;color:white;font-size:1.2rem">
									Contacts
								</v-card-title>

								<v-card-title class="footer-light-text" style="padding-top:5px;padding-bottom:4px">
									office@lingoav.com
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px">
									+359 888829364
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px">
									ul. "Vasil Aprilov" 52
									<div>3400, Montana, Bulgaria</div>
								</v-card-title>
							</v-card>
							</v-layout>
						</v-flex>


						<v-flex sm12 md4 class="relative">
							<v-layout column align-center>
							<v-card class="relative transparent elevation-0"  width="400px">

								<v-card-title primary-title style="padding-bottom:0px;padding-top:38px;padding-bottom:5px;color:white;font-size:1.2rem">
									Attributions
								</v-card-title>

								<v-card-title class="footer-light-text" style="padding-top:5px;padding-bottom:4px">
									Shoutout to our friends who made this service possible
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px;padding-left:9px;">
									<a href="https://vuetifyjs.com" target="_blank" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Vuetify</a> - front-end
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px;padding-left:9px;">
									<a href="https://www.freepik.com" target="_blank" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Freepik</a> - vectors
								</v-card-title>
							</v-card>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-container>

		</section>


		<!-- mobile version -->
		<section class="relative nooverflow pt-5 blue-grey darken-3 hidden-md-and-up" style="--background:#424242;--height:280px">

		<div style="height: 100px;width: 100%;background: linear-gradient(170deg, rgba(64, 79, 86, 0.92), rgb(55, 71, 79));position: absolute;top: -54px;transform: rotate(181deg);">.</div>

					<v-layout row wrap class="relative" style="padding-bottom:3rem">

						<img src="../../../assets/lingoLogo.png" style="position:absolute;right:10%;bottom:10%;opacity: 0.1;transform:scale(1.5)"/>

						<v-flex sm12 lg4 class="relative">
							<v-layout column align-start>
							<v-card class="relative transparent elevation-0" width="370px">

								<v-card-title primary-title style="padding-bottom:0px">
									<span style="color:rgb(187, 187, 187);padding-top: 5px;padding-bottom: 0px;position: relative;font-size:2rem">LingoAV &copy; {{ new Date().getFullYear() }}</span>
								</v-card-title>

								<v-card-text style="padding-top: 5px;padding-left: 7px;position: relative;">

									<div class="mb-1"><router-link to="/programInfo"  class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Project Info</router-link></div>
									<div class="mb-1"><router-link to="/terms"  class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Terms of Service</router-link></div>
									<div class="mb-1"><router-link to="/legal"  class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Privacy Policy</router-link></div>
									<div class="mb-1"><router-link to="/cookiePolicy"  class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Cookie Policy</router-link></div>

								</v-card-text>
							</v-card>
							</v-layout>
						</v-flex>


						<v-flex sm12 lg4 class="relative">
							<v-layout column align-start>
							<v-card class="relative transparent elevation-0"  width="250px">

								<v-card-title primary-title style="padding-bottom:0px;padding-top:38px;padding-bottom:5px;color:white;font-size:1.2rem">
									Contacts
								</v-card-title>

								<v-card-title class="footer-light-text" style="padding-top:5px;padding-bottom:4px">
									office@lingoav.com
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px">
									+359 888829364
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px">
									ul. "Vasil Aprilov" 52
									<div>3400, Montana, Bulgaria</div>
								</v-card-title>
							</v-card>
							</v-layout>
						</v-flex>


						<v-flex sm12 lg4 class="relative">
							<v-layout column align-start>
							<v-card class="relative transparent elevation-0"  width="400px">

								<v-card-title primary-title style="padding-bottom:0px;padding-top:38px;padding-bottom:5px;color:white;font-size:1.2rem">
									Attributions
								</v-card-title>

								<v-card-title class="footer-light-text" style="padding-top:5px;padding-bottom:4px">
									Shoutout to our friends who made this service possible
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px;padding-left:9px;">
									<a href="https://vuetifyjs.com" target="_blank" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Vuetify</a> - front-end
								</v-card-title>
								<v-card-title class="footer-light-text" style="padding-top:0px;padding-bottom:4px;padding-left:9px;">
									<a href="https://www.freepik.com" target="_blank" class="ml-2 mr-2" style="color:rgb(247, 247, 245)">Freepik</a> - vectors
								</v-card-title>
							</v-card>
							</v-layout>
						</v-flex>
					</v-layout>

		</section>

		</div>
</template>

<style scoped>

.footer-light-text {
	color:rgb(187, 187, 187);
}

</style>

<script>

export default {
  name: "contacts_section",
  data() {
    return {
    };
  }
};
</script>
